import React, { useEffect, useState } from "react";
import PageHeader from "../../../shared/PageHeader";
import { FaCalendar, FaHospital } from "react-icons/fa";
import useFetchData from "../../../hooks/UseFetchData";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CustomTable from "../../../shared/CustomTable";
import { MdOutlineTrackChanges } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { AppTableFields } from "../../../constants/AppointmentConstants";
import moment from "moment";
import CustomPagination from "../../../shared/CustomPagination";

function ProfileAppointments() {
  const selectedPatientData = useSelector(
    (state) => state?.beneficiary?.seletedPatientData
  );
  const isGeneralSearch = useSelector(
    (state) => state?.beneficiary?.isGeneralSearch
  );
  const { data, loading, executeFetch } = useFetchData();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [payload, setPaylaod] = useState({
    page: 1,
    perpage: 10,
    file_no: selectedPatientData?.file_no,
  });

  const fetchInitialData = async (payloadData = payload) => {
    const res = await executeFetch(
      "POST",
      "/v3/patient/appointment/filter",
      payloadData
    );
  };

  useEffect(() => {
    fetchInitialData();
  }, [payload?.page, payload?.perpage]);

  const actions = {
    header: t("Actions"),
    body: ActionTempelate,
  };
  const onPageChange = async (newPage, newRowsPerPage) => {
    let payloadDt = {
      ...payload,
      page: newPage,
      perpage: newRowsPerPage,
    };
    setPaylaod(payloadDt);
  };

  function ActionTempelate(row) {
    const endDateTimeStr = row?.appointment_date + " " + row?.end_time;
    const endTime = moment(endDateTimeStr, "YYYY-MM-DD HH:mm");
    const currentTime = moment();
    return (
      <div className="flex gap-1">
        <MdOutlineTrackChanges
          size={18}
          className="text-primary cursor-pointer ms-2"
          title={t("Track")}
          onClick={async () => {
            navigate(`/appointment-history/${row?.appointment_id}`, {
              state: { rowData: row },
            });
          }}
        />
      </div>
    );
  }
  const columns = [
    actions,
    ...AppTableFields(t, { filters: { status: "Cancelled" } }),
  ];
  return (
    <div className="main-page-container">
      <PageHeader
        title={t("Patient Appointments")}
        Icon={FaCalendar}
      ></PageHeader>
      <div className="mt-4">
        <CustomTable
          data={data?.data || []}
          columns={columns}
          isLoading={loading}
          emptyMessage={t("No Appointment Data Found")}
        />
        {data?.data?.length > 0 && (
          <CustomPagination
            currentPage={data?.page}
            rowsPerPage={data?.perPage}
            totalRecords={data?.totalCount}
            totalPages={data?.totalPages}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}

export default ProfileAppointments;
